const physical = {
    jpath: ['physical'],
    getEmpty() {
        return {};
    },
};
export default physical;
//# sourceMappingURL=physical.js.map